import { action, makeObservable, observable } from 'mobx'

export const CLOSE = Symbol('close')

export type Closable = {
  [CLOSE]: () => unknown
}

export function isClosable(object: unknown): object is Closable {
  if (object == null) return false
  if (typeof object !== 'object') return false
  return CLOSE in object && typeof object[CLOSE] == 'function'
}

export class MxRef<V> {
  private value: V | null = null

  constructor(value?: V) {
    this.value = value ?? null
    makeObservable<this, 'value'>(this, {
      value: observable.ref,
    })
  }

  get present(): boolean {
    return this.value != null
  }

  get it(): V {
    if (this.value == null) throw new Error('no it')
    return this.value
  }

  get optional(): V | undefined {
    return this.value ?? undefined
  }

  set it(value: V | undefined) {
    this.set(value)
  }

  open(value: V) {
    this.set(value)
  }

  close() {
    if (isClosable(this.value)) {
      try {
        this.value[CLOSE]()
      } catch (e) {
        console.error('close failed', e)
      }
    }
    this.set(undefined)
  }

  private set = action((value: V | undefined) => {
    this.value = value ?? null
  })
}
